/**
 * Formatiert einen Betrag in der angegebenen Währung.
 * @param {number} amount - Der zu formatierende Betrag.
 * @param {string} currency - Die Währung (z.B. 'USD', 'EUR').
 * @param {string} locale - Das Sprach- und Länderkürzel zur Formatierung (optional, Standard ist 'de-DE').
 * @param {number} [minDigits] - The optional minimumFractionDigits, default = 2.
 * @returns {string} Der formatierte Betrag als String.
 */
export function currencyFormatter(amount, currency = 'EUR', locale = 'de-DE', minDigits = 2) {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: minDigits,
    maximumFractionDigits: 2,
  }).format(amount);
}

/**
 * Berechnet und rundet einen Betrag auf zwei Dezimalstellen.
 * @param {number} amount - Der Betrag, der gerundet werden soll.
 * @returns {number} Der gerundete Betrag.
 */
export function roundAmount(amount) {
  return Math.round((amount + Number.EPSILON) * 100) / 100;
}
